<template lang="pug">
  #form
    v-layout(row justify-center)
      v-dialog(v-model="dialog" persistent max-width="850")
        v-card.py-5
            p.headline.text-xs-center ¿Estás seguro de que quieres borrar este folio?
            //v-card-text xxxxxx
            v-spacer.mt-4
            v-layout.px-5
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.purple-btn.bold(@click.native="dialog = false") CANCELAR
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.purple-btn.bold(@click.native="deleteReport") ELIMINAR FOLIO
    Header
    v-container(fluid)
      v-layout(row wrap)
        v-flex(xs12 sm2)
          v-layout(column)
            Side
        v-flex(xs10)
          v-layout(row wrap)
            v-flex#top(xs6)
              h1.form-title.purple-text Postal
            v-flex(xs6 v-if="user.role === 'admin' || user.role === 'Administración'")
              v-layout(row wrap)
                v-flex(xs4)
                  p.text-xs-center Folio Privado
                v-flex(xs1)
                  v-switch(color="#462979" v-model="public")
                v-flex(xs4)
                  p.text-xs-center Folio Público
            v-flex.postal(xs12 sm12 md7)
              v-layout(column)
                Postal
            v-flex(xs12 sm12 md5)
              v-layout(column)
                PostalForm
          v-divider.form.my-4
          v-layout(row wrap)
            v-flex(xs12)
              Location
          v-divider.form.my-4
          v-layout(row wrap)
            v-flex(xs12)
              Victims
          v-divider.form.my-4
          v-layout(v-if="isEditing" row wrap)
            v-flex(xs12)
              Updates
          v-divider.form.my-4(v-if="isEditing")
          v-layout(v-if="isEditing" row wrap)
            v-flex(xs12)
              Edit
          v-layout(row wrap)
            v-flex(v-if="isEditing" xs6 justify-start)
              v-btn.purple-btn.bold(v-on:click="openDialog") Eliminar este folio
            v-flex(xs6 justify-end)
              v-btn.purple-btn.bold(
                to="/"
              ) Cancelar
              v-btn.purple-btn.bold(v-if="!isEditing", v-on:click="createReport") Guardar
              v-btn.purple-btn.bold(v-if="isEditing", v-on:click="updateReport") Guardar

</template>

<script>
import * as d3 from "d3";
import * as html2canvas from "html2canvas";
import Header from "@/components/Header.vue";
import Side from "@/components/Side.vue";
import PostalForm from "@/components/PostalForm.vue";
import Postal from "@/components/Postal/Postal.vue";
import Location from "@/components/Location.vue";
import Victims from "@/components/Victims.vue";
import Updates from "@/components/Updates.vue";
import Edit from "@/components/Edit.vue";

export default {
  name: "Form",
  props: {},
  components: {
    Header,
    Side,
    PostalForm,
    Postal,
    Location,
    Victims,
    Updates,
    Edit
  },
  data() {
    return {
      record: this.$store.state.record,
      dialog: false,
      user: this.$store.state.user
    };
  },
  computed: {
    isEditing() {
      let edit = this.$store.state.editing;
      return edit;
    },
    public: {
      get() {
        return this.$store.state.record.public;
      },
      set(value) {
        this.$store.commit("updatePublic", value);
      }
    }
  },
  methods: {
    createReport() {
      // console.log(this.record)
      if (
        this.record.aggression_datetime === "" ||
        typeof this.record.aggression_datetime === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección fecha de agresión incompleta"
        });
      } else if (
        this.record.verification_datetime === "" ||
        typeof this.record.verification_datetime === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección fecha de verificación incompleta"
        });
      } else if (
        this.record.state === "" ||
        typeof this.record.state === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección entidad incompleta"
        });
      } else if (
        this.record.municipality === "" ||
        typeof this.record.municipality === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección municipio incompleta"
        });
      } else if (
        this.record.aggression_type.length === 0 ||
        typeof this.record.aggression_type === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección tipo de agresión incompleta"
        });
      } else if (
        this.record.aggression_subtype.length === 0 ||
        typeof this.record.aggression_subtype === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección subtipo de agresión incompleta"
        });
      } else if (
        this.record.details === "" ||
        typeof this.record.details === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección más información incompleta"
        });
      } else if (
        this.record.place === "" ||
        typeof this.record.place === "undefined" ||
        this.record.address === "" ||
        typeof this.record.address === "undefined" ||
        this.record.lat === "" ||
        typeof this.record.lat === "undefined" ||
        this.record.lng === "" ||
        typeof this.record.lng === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección ubicación en el mapa incompleta"
        });
      } else if (
        this.record.victims.length === 0 ||
        typeof this.record.victims === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección de víctimas incompleta"
        });
      } else {
        this.$store.commit("setIsLoadingState", true);
        this.$store
          .dispatch("createReport")
          .then(response => {
            // UploadImage request
            this.uploadImage(response.data.folio)
              .then(result => {
                // console.log(result)
                this.$store.commit("SET_CREATEREPORT_SUCCESS", {
                  pending: false,
                  statusCode: response.status,
                  data: response.data
                });
                this.$notify({
                  group: "foo",
                  type: "success",
                  title: "ÉXITO",
                  text: response.data.message
                });
                this.$store
                  .dispatch("sendPushNotification", {
                    title: `NUEVA AGRESIÓN #${response.data.folio} ${
                      this.record.aggression_type
                    }`,
                    body: `${this.record.aggression_subtype} - ${
                      this.record.details
                    }`,
                    click_action: result.url
                  })
                  .then(() => {
                    // console.log(response)
                  })
                  .catch(() => {
                    // console.log(error)
                    // console.log(error.response)
                  });
                this.record.review_reason = "right";
                this.record.review_comments = "";
                this.record.id = response.data.result["_id"];
                this.record.folio = response.data.folio;
                // console.log(this.record)
                // console.log(response)
                this.$store
                  .dispatch("addReview")
                  .then(() => {
                    // console.log(response)
                    this.$store.commit("resetReview");
                  })
                  .catch(() => {
                    // console.log(error)
                    // console.log(error.response);
                  });
                this.$store.commit("resetRecord");
                this.$router.replace("/");
                this.$store.commit("setIsLoadingState", false);
              })
              .catch(err => {
                console.log(err);
              });

            // UpdateCsv request
            this.updateCsv();
          })
          .catch(error => {
            console.log(error);
            // console.log(error.response);
            this.$store.commit("SET_CREATEREPORT_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              type: "error",
              title: "ERROR",
              text: error.response.data.message
            });
            this.$store.commit("setIsLoadingState", false);
          });
      }
    },
    updateReport() {
      // console.log('original record', this.record)
      //Remove empty victims
      for (let index = 0; index < this.record.victims.length; index++) {
        var victim = this.record.victims[index];
        if (
          (victim.media === "" || typeof victim.media === "undefined") &&
          (victim.name === "" || typeof victim.name === "undefined") &&
          (victim.position === "" || typeof victim.position === "undefined")
        ) {
          // console.log('delete', index);
          this.record.victims.splice(index, 1);
          index = 0;
        }
      }
      // console.log('medium', this.record.victims);
      // Check if id exists
      if (this.record.id === "" || typeof this.record.id === "undefined") {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Ocurrio un error interno, por favor intenta de nuevo"
        });
        this.$router.replace("/");
      } else if (
        this.record.aggression_datetime === "" ||
        typeof this.record.aggression_datetime === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección fecha de agresión incompleta"
        });
      } else if (
        this.record.verification_datetime === "" ||
        typeof this.record.verification_datetime === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección fecha de verificación incompleta"
        });
      } else if (
        this.record.state === "" ||
        typeof this.record.state === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección entidad incompleta"
        });
      } else if (
        this.record.municipality === "" ||
        typeof this.record.municipality === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección municipio incompleta"
        });
      } else if (
        this.record.aggression_type.length === 0 ||
        typeof this.record.aggression_type === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección tipo de agresión incompleta"
        });
      } else if (
        this.record.aggression_subtype.length === 0 ||
        typeof this.record.aggression_subtype === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección subtipo de agresión incompleta"
        });
      } else if (
        this.record.details === "" ||
        typeof this.record.details === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección más información incompleta"
        });
      } else if (
        this.record.place === "" ||
        typeof this.record.place === "undefined" ||
        this.record.address === "" ||
        typeof this.record.address === "undefined" ||
        this.record.lat === "" ||
        typeof this.record.lat === "undefined" ||
        this.record.lng === "" ||
        typeof this.record.lng === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección ubicación en el mapa incompleta"
        });
      } else if (
        this.record.victims.length === 0 ||
        typeof this.record.victims === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Sección de víctimas incompleta"
        });
      } else {
        // console.log('final', this.record);
        this.$store.commit("setIsLoadingState", true);
        this.$store
          .dispatch("updateReport")
          .then(response => {
            // UploadImage request
            this.uploadImage(response.data.folio)
              .then(result => {
                this.$store.commit("SET_UPDATEREPORT_SUCCESS", {
                  pending: false,
                  statusCode: response.status,
                  data: response.data
                });
                this.$notify({
                  group: "foo",
                  type: "success",
                  title: "ÉXITO",
                  text: response.data.message
                });
                this.$store
                  .dispatch("sendPushNotification", {
                    title: `ACTUALIZACIÓN #${response.data.folio} ${
                      this.record.aggression_type
                    }`,
                    body: `${this.record.aggression_subtype} - ${
                      this.record.details
                    }`,
                    click_action: result.url
                  })
                  .then(() => {
                    // console.log(response)
                  })
                  .catch(() => {
                    // console.log(error)
                    // console.log(error.response)
                  });
                this.$store.state.record.review_reason = "right";
                this.$store.state.record.review_comments = "";
                this.$store
                  .dispatch("addReview")
                  .then(() => {
                    // console.log(response)
                    this.$store.commit("resetReview");
                  })
                  .catch(() => {
                    // console.log(error)
                    // console.log(error.response);
                  });
                this.$store.commit("resetRecord");
                this.$router.replace("/");
                this.$store.commit("setIsLoadingState", false);
              })
              .catch(err => {
                console.log(err);
              });

            // UpdateCsv request
            this.updateCsv();
          })
          .catch(error => {
            console.log(error);
            // console.log(error.response);
            this.$store.commit("SET_UPDATEREPORT_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            this.$notify({
              group: "foo",
              type: "error",
              title: "ERROR",
              text: error.response.data.message
            });
            this.$store.commit("setIsLoadingState", false);
          });
      }
    },
    deleteReport() {
      this.dialog = false;
      this.$store.commit("setIsLoadingState", true);
      this.$store
        .dispatch("deleteReport")
        .then(response => {
          // console.log(response)
          this.$store.commit("SET_DELETEREPORT_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
          this.$notify({
            group: "foo",
            type: "success",
            title: "ÉXITO",
            text: response.data.message
          });
          this.$store
            .dispatch("sendPushNotification", {
              title: `ELIMINADA #${response.data.folio} ${
                this.record.aggression_type
              }`,
              body: `${this.record.aggression_subtype} - ${
                this.record.details
              }`,
              click_action: ""
            })
            .then(() => {
              // console.log(response)
            })
            .catch(() => {
              // console.log(error)
              // console.log(error.response)
            });
          this.$store.commit("resetRecord");
          this.$router.replace("/");
          this.$store.commit("setIsLoadingState", false);

          // UpdateCsv request
          // console.log('bout to delete!');
          this.updateCsv();
        })
        .catch(error => {
          // console.log(error)
          // console.log(error.response);
          this.$store.commit("SET_DELETEREPORT_FAILURE", {
            pending: false,
            statusCode: error.status
          });
          this.$notify({
            group: "foo",
            type: "error",
            title: "ERROR",
            text: error.response.data.message
          });
          this.$store.commit("setIsLoadingState", false);
        });
    },
    uploadImage(folio) {
      // console.log("upload image");

      return new Promise((resolve, reject) => {
        html2canvas(d3.select("#postal").node()).then(canvas => {
          let imageData = {
            folio: folio,
            file: canvas.toDataURL("image/png")
          };

          this.$store
            .dispatch("uploadImage", imageData)
            .then(response => {
              this.$store.commit("SET_UPLOADIMAGE_SUCCESS", {
                pending: false,
                statusCode: response.status
              });
              return resolve(response.data);
            })
            .catch(error => {
              this.$store.commit("SET_UPLOADIMAGE_FAILURE", {
                pending: false,
                statusCode: error.status
              });
              return reject("error");
            });
        });
      });
    },
    updateCsv() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("updateCsv")
          .then(response => {
            this.$store.commit("SET_UPDATECSV_SUCCESS", {
              pending: false,
              statusCode: response.status
            });
            return resolve("ok");
          })
          .catch(error => {
            this.$store.commit("SET_UPDATECSV_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            return reject("error");
          });
      });
    },
    openDialog() {
      this.dialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
p.headline {
  color: #462979;
  font-family: "Rajdhani", sans-serif;
  font-size: 30px !important;
  font-weight: 600;
}
.postal {
  min-width: 570px;
}
</style>
